import React, { useEffect, useState } from "react";
import "./questions-list.component.scoped.scss";
import { Box } from "@material-ui/core";
import { QuestionsService } from "../../../../../services/questions.services";
import { DataTableComponent } from "../../../../../components/table/data-table/data-table.component";
import { questionsColumns } from "../../../../../statics/table-columns/questionsColumns";
import { useTranslation } from "react-i18next";

const QuestionsListComponent = (props: any) => {
  const { t } = useTranslation();
  const { onSelectQuesion } = props;
  const questionsService: QuestionsService = new QuestionsService();
  const [questions, setQuestions] = useState<any>([]);

  const tableInintData: any = {
    users: [],
    filter: {
      role: "",
      searchText: "",
      status: null,
    },
    columns: questionsColumns,
    options: {
      withSort: true,
      sortDirection: "asc",
      sortColumn: "",
    },
    pagination: {
      currentPage: 1,
      items: 15,
      totalPages: 1,
      total: 0,
    },
  };

  const paginateTable = (pagination: any) => {
    // const { items, currentPage } = pagination;
    // const params = {
    //   items,
    //   page: currentPage,
    //   order: tableInintData.options.sortDirection,
    //   sort: tableInintData.options.sortColumn,
    // };
    fetchData();
  };

  const fetchData = async () => {
    const questions = await questionsService.list();
    setQuestions(questions);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="questions__list_content">
      <DataTableComponent
        tableName="questions"
        loading={false}
        // reset={reset}
        columns={questionsColumns}
        data={questions}
        options={tableInintData.options}
        sort={tableInintData.sortTable}
        pagination={tableInintData.pagination}
        paginate={paginateTable}
        title={t("SETTINGS_PAGES.QUESTIONS_BUILDER.LIST_OF_QUESTIONS")}
        subTitle={""}
        reload={false}
        // filter={filter}
        // onFilterChange={filterChange}
        // refresh={refresh}
        onSelectedRow={onSelectQuesion}
        clickableRow={true}
      />
    </Box>
  );
};

export default QuestionsListComponent;
